import dayjs from 'dayjs';
import weekOfYear from 'dayjs/plugin/weekOfYear';

dayjs.extend(weekOfYear);

const formatRange = ({ week, year, weeksBack }) => {
    const date = dayjs().week(week).year(year).startOf('week');
    const from = date.subtract(weeksBack, 'week').format('MMM D');
    const to = date.format('MMM D');
    if (from.slice(0, 3) === to.slice(0, 3)) {
        return `${from} - ${to.slice(3)}`;
    }
    return `${from} - ${to}`;
};

// Bare date ranges (no metric prefix) used by the rank-type dropdown labels.
export const getWeekRange = ({ week, year }) =>
    formatRange({ week, year, weeksBack: 1 });

export const getMonthRange = ({ week, year }) =>
    formatRange({ week, year, weeksBack: 4 });
